(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/payment-success.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/payment-success.js');

'use strict';

class PaymentSuccess extends svs.tur.payment.dialogs.DialogBase {
  constructor(_ref) {
    let {
      onConfirm,
      andraChansen
    } = _ref;
    super({
      onConfirm
    });
    this.myBetsHomeQueryParam = "?grassrootstoasterredirect";
    this.sponsors = null;
    this.andraChansen = andraChansen;

    this.loadGrasrotenSponsors().done(_ref2 => {
      let {
        sponsors
      } = _ref2;
      this.sponsors = sponsors;
      this.show();
    }).fail(() => {
      this.show();
    });
  }
  loadGrasrotenSponsors() {
    const deferred = $.Deferred();
    svs.tur.usersettings.get({
      key: 'receivers'
    }).done(_ref3 => {
      let {
        value
      } = _ref3;
      const sponsors = this.parseGrasrotenData(value);
      if (sponsors) {
        deferred.resolve({
          sponsors
        });
      }
      return deferred.reject();
    }).catch(error => deferred.reject(error));
    return deferred.promise();
  }
  getIcon() {
    return "thumbs-up";
  }
  getTitle() {
    return 'Ditt spel är betalat. Lycka till!';
  }
  getMessage() {
    const message = [];
    let hasExtraChances = false;
    const link = "<a href=\"".concat(svs.core.urlMapping.get('myBetsHome')).concat(this.myBetsHomeQueryParam, "\" class=\"alert-text-link\">Mina spel</a>");
    if (this.andraChansen) {
      hasExtraChances = true;
    }
    message.push({
      type: svs.components.dialog.message.TEXT,
      text: "Se dina lagda spel".concat(hasExtraChances ? ' och extra chanser' : '', " i ").concat(link, "."),
      align: svs.components.dialog.message.align.CENTER
    });
    if (this.sponsors) {
      message.push({
        type: svs.components.dialog.message.TEXT,
        text: "".concat(this.sponsors, " tackar f\xF6r ditt st\xF6d genom Gr\xE4sroten!"),
        align: svs.components.dialog.message.align.CENTER
      });
    }
    return message;
  }
  getActions() {
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Okej',
      callback: (e, form, dialog) => {
        dialog.close();
        this.onConfirm && this.onConfirm();
      }
    }];
  }
  parseGrasrotenData(data) {
    if (data) {
      let sponsors = '';
      for (let i = 0; i < data.length; i++) {
        if (i > 0) {
          if (i === data.length - 1) {
            sponsors += ' och ';
          } else {
            sponsors += ', ';
          }
        }
        sponsors += data[i];
      }
      return sponsors;
    }
    return null;
  }
}
svs.tur.payment.dialogs.PaymentSuccess = PaymentSuccess;

 })(window);